export default {
    lang: {
        name: 'Date updated'
    }
}